// src/lib/opportunity/formatSettingsResolver.ts

import { getFormatSettings } from "./formatSettingsClient";
import {
  selectFormatSettings,
  type FormatSettingsDef,
} from "./formatSettingsTypes";
import type { OpportunityFormatKey } from "@/types/opportunity";
import { FORMAT_CALC_PRODUCT_TYPE_WILDCARD } from "./formatCalcLineTypes";

export async function resolveFormatSettings(args: {
  formatKey: OpportunityFormatKey;
  productType: string;
}): Promise<FormatSettingsDef> {
  const [specific, wildcard] = await Promise.all([
    getFormatSettings({ format_key: args.formatKey, product_type: args.productType }),
    getFormatSettings({
      format_key: args.formatKey,
      product_type: FORMAT_CALC_PRODUCT_TYPE_WILDCARD,
    }),
  ]);
  const rows = [];
  if (specific.ok && specific.data.settings) rows.push(specific.data.settings);
  if (wildcard.ok && wildcard.data.settings) rows.push(wildcard.data.settings);
  return selectFormatSettings({ rows, productType: args.productType });
}
